import { useTheme } from '@emotion/react';
import { getServiceName } from '@repo/utils';
import cn from 'classnames';

import { IConDefaultType } from '../types';

export interface IScrollUpIconProps extends IConDefaultType {}

function ScrollUpIcon({ color, className, size = 60, rotate, flip }: IScrollUpIconProps) {
  const theme = useTheme();
  const serviceName = getServiceName();
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {serviceName === 'bubblechat' && (
        <svg viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g filter="url(#filter0_d_5_2657)">
            <path
              d="M26 3C37.0457 3 46 11.9543 46 23C46 34.0457 37.0457 43 26 43C14.9543 43 6 34.0457 6 23C6 11.9543 14.9543 3 26 3Z"
              fill={theme.color.static.primary}
            />
          </g>
          <path
            d="M20.7314 26.5607C20.1065 27.1464 19.0935 27.1464 18.4686 26.5607C17.8438 25.9749 17.8438 25.0251 18.4686 24.4393L24.8686 18.4393C25.4935 17.8536 26.5065 17.8536 27.1314 18.4393L33.5314 24.4393C34.1562 25.0251 34.1562 25.9749 33.5314 26.5607C32.9065 27.1464 31.8935 27.1464 31.2686 26.5607L26 21.6213L20.7314 26.5607Z"
            fill={theme.color.label.onAccent}
          />
          <defs>
            <filter
              id="filter0_d_5_2657"
              x="0"
              y="0"
              width="52"
              height="52"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0.764706 0 0 0 0 0.866667 0 0 0 0.3 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5_2657" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5_2657" result="shape" />
            </filter>
          </defs>
        </svg>
      )}
      {serviceName === 'tingle' && (
        <svg viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g filter="url(#filter0_d_6198_314405)">
            <path
              d="M26 3C37.0457 3 46 11.9543 46 23C46 34.0457 37.0457 43 26 43C14.9543 43 6 34.0457 6 23C6 11.9543 14.9543 3 26 3Z"
              fill={theme.color.static.primary}
            />
          </g>
          <path
            d="M20.7314 26.5607C20.1065 27.1464 19.0935 27.1464 18.4686 26.5607C17.8438 25.9749 17.8438 25.0251 18.4686 24.4393L24.8686 18.4393C25.4935 17.8536 26.5065 17.8536 27.1314 18.4393L33.5314 24.4393C34.1562 25.0251 34.1562 25.9749 33.5314 26.5607C32.9065 27.1464 31.8935 27.1464 31.2686 26.5607L26 21.6213L20.7314 26.5607Z"
            fill={theme.color.label.onAccent}
          />
          <defs>
            <filter
              id="filter0_d_6198_314405"
              x="0"
              y="0"
              width="52"
              height="52"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="3" />
              <feComposite in2="hardAlpha" operator="out" />
              {/*
                그림자 색 = brand/primary(#F95388) 30%. SVG 필터 행렬은 CSS 토큰을 받지 못해
                RGB를 0~1로 직접 적는다 — 브랜드 컬러가 바뀌면 여기도 같이 바꿔야 한다.
                (리브랜딩 전 값 #FFF820이 남아 버튼 뒤에 노란 그림자가 깔려 있었다)
              */}
              <feColorMatrix type="matrix" values="0 0 0 0 0.976471 0 0 0 0 0.32549 0 0 0 0 0.533333 0 0 0 0.3 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6198_314405" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_6198_314405" result="shape" />
            </filter>
          </defs>
        </svg>
      )}
    </i>
  );
}

export default ScrollUpIcon;
